// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Container } from '../../components/Elemental'
import _ from 'lodash'

// CSS
import './styles.scss'

// Actions
import { changeOnboarding } from './actions'

class Onboarding extends Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { invited, user, onboarding, spCases, spCase, changeOnboarding } = this.props
    const nextSpCases = nextProps.spCases
    const nextSpCase = nextProps.spCase

    // Open only if it is invited
    if (invited) {
      // Step 1
      if (onboarding.step === 0 && _.isEmpty(spCases) && !_.isEmpty(nextSpCases)) {
        changeOnboarding({ ...onboarding, visible: true, step: 1, question: 'Acessando um caso', text: 'Cada um destes retangulos representa um caso seu. Clique no caso que deseja visualizar.', button: 'Entendi', marginLeft: '15px', marginTop: '270px' })
      }
      // Step 2
      if (onboarding.step === 1 && !_.isEmpty(nextSpCase.chat) && nextSpCase.chat[0] && nextSpCase.chat[0].allowed === 'lawyer') {
        changeOnboarding({ ...onboarding, visible: true, step: 2, question: 'Iniciando a negociação', text: 'Ao clicar "Negociar" você irá iniciar a negociação. Lembramos que este ato não te vincula a um acordo, mas somente mostra a outra parte que você está disposto a negociar.', button: 'Entendi', marginLeft: '8px', marginTop: '425px' })
      }
      // Step 3
      if (onboarding.step === 2 && !_.isEmpty(nextSpCase.chat) && nextSpCase.chat[1] && nextSpCase.chat[1].allowed === 'company' && !nextSpCase.message) {
        changeOnboarding({ ...onboarding, visible: true, step: 3, question: 'Messagem Automática', text: 'Parabéns, você aceitou negociar! Nós já lidamos com as formalidades e enviamos esta mensagem de aceite para a empresa. Agora é só relaxar e aguardar a proposta. Fique de olho em seu email e/ou sms que iremos indicar qualquer atualização.', button: 'Entendi', marginLeft: '450px', marginTop: '490px' })
      }
      // Step 4
      // if((onboarding.step === 2 || onboarding.step === 3) && nextSpCases.length > 1) {
      //   changeOnboarding({ ...onboarding, visible: true, step: 4, question: 'Resolva suas pendências', text: 'Você possui outro caso. Clique no caso para visualizar e iniciar uma outra negociação', button: 'Entendi', marginLeft: '20px', marginTop: '425px'})
      // }
    }
  }

  onContinue = () => {
    const { onboarding, changeOnboarding } = this.props

    if (onboarding.visible) {
      changeOnboarding({ ...onboarding, visible: false })
    }
  }

  render() {
    const { onboarding: { visible, step, question, text, button, marginLeft, marginTop }, changeOnboarding } = this.props
    const { onContinue, onStop } = this

    const onboardingBoxStyle = {
      marginLeft,
      marginTop
    }

    if (visible) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }

    return (
      <div className={visible ? "onboarding onboarding--visible" : "onboarding"}>
        <Container>
          <div style={onboardingBoxStyle} className="onboarding__box">
            <span className="onboarding__arrow-up"></span>
            <div className="onboarding__content">
              <p>{question}</p>
              <i className="material-icons" onClick={() => onContinue()}>close</i>
            </div>
            <p>{text}</p>
            <div className="onboarding__buttons">
              <span
                onClick={() => onContinue()}>
                {button}
              </span>
            </div>
          </div>
        </Container>
      </div>
    )
  }
}

Onboarding = connect(
  (state, ownProps) => ({
    invited: state.auth.invited,
    user: state.auth.user,
    onboarding: state.onboarding,
    spCases: state.myCasesPage.spCases,
    spCase: state.spCasePage.spCase
  }), { changeOnboarding })(Onboarding)


export default Onboarding
